/**
 * AttivitaPulizie - Page Shell
 * Lista pulizie
 */

import { PulizieList } from "@/features/attivita/components/PulizieList";

export default function AttivitaPulizie() {
  return <PulizieList />;
}
